import React from 'react';

import { ClickAwayListener, MenuList, MenuItem } from '@mui/material';

import { InventoryAdjustment } from 'commons/types';

import { RowMenuItemConfig } from '../configs/row-menu-item.config';

interface ActionBtnMenuInventoryAdjustmentProps {
  selectedTask: InventoryAdjustment[];
  handleCloseMenu: () => void;
  handleOpen: (name: string) => void;
}

export const ActionBtnMenuInventoryAdjustment: React.FC<
  ActionBtnMenuInventoryAdjustmentProps
> = ({ selectedTask, handleCloseMenu, handleOpen }) => {
  return (
    <ClickAwayListener onClickAway={handleCloseMenu}>
      <MenuList id="split-button-menu" autoFocusItem>
        {RowMenuItemConfig.map((config) => (
          <MenuItem
            onClick={() => handleOpen(config.name)}
            disabled={config.disabled(selectedTask)}
            key={`menu-item-${config.name}`}
          >
            {config.name}
          </MenuItem>
        ))}
      </MenuList>
    </ClickAwayListener>
  );
};
